import { useEffect, useState } from 'react';
import { VotesCardBig } from './voteCardBig';
import Arrow from 'assets/images/svg/icon_arrow-up-white.svg';

import { Loader } from 'components/loader/loader';
import axios from 'axios';
import { Link } from 'react-router-dom';
// import { useAuthState } from 'context';

export const MainVotes = () => {
  const [votes, setVotes] = useState([]);
  const [loading, setLoading] = useState(true);
  // const { token } = useAuthState()

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND}/nomination`).then((data) => {
      setVotes(data.data);
      setLoading(false);
    });
  }, []);

  const renderBlocks = () => {
    if (!loading && votes.data) {
      return votes.data.map((newsItem, index) => {
        return index <= 3 && <VotesCardBig key={newsItem.id} news={newsItem} />;
      });
    }
  };

  if (loading) return <Loader />
  if (votes.data.length === 0) return null

  return (
    <section className='news'>
      <div className='container'>
        <div className='contest__title title'>Поданные заявки</div>
        <div className='news__list'>{renderBlocks()}</div>
        <Link className='nomination__file' to={'/voting'}>
          Смотреть всё
          <img src={Arrow} style={{ width: '20px', height: '20px', transform: 'rotate(90deg)' }} alt='' />
        </Link>

        {/* <div className='calendar__banner calendar__banner_blue'>
          <div className='calendar__banner-text'>
            <h3>Принять участие в народном голосовании</h3>
            <span>
              Для участия в голосовании вам необходимо зарегистрироваться или
              авторизоваться
            </span>
          </div>
          <Link to={!token ? '/login' : '/voting'}>
            <button className='main__btn button' type='button'>
              Проголосовать
            </button>
          </Link>
        </div> */}
      </div>
    </section>
  );
};
